module.exports = __webpack_public_path__ + "img/text-app-title.85065fba.svg";